import '../css/app.scss';
import './script/neto.js';
import './script/popupCalls';

import lazyLoad from './script/lazyLoad';
import mobMenu from './script/mobMenu';
import megamenu from './script/megamenu';
import headerHoverPopups from './script/headerHoverPopups';
import stickyHeader from './script/stickyHeader';
import showHide from './script/showHide';
import readMore from './script/readmore';
import sliders from './script/slider';
import accordian from './script/accordian';
import storeFinder from './script/storeFinder';
import catToggle from './script/catToggle';
import dropdown from './script/dropdowns';
import detectSticky from './script/detectSticky';
import breadcrumbs from './script/breadcrumbs';
import stickySidebar from './script/stickySidebar';
import { addEvent, appHeight } from './script/utils';

lazyLoad.init();
mobMenu.init();
megamenu.init();
headerHoverPopups.init();
stickyHeader.init();
showHide.init();
readMore.init();
sliders.init();
accordian.init();
storeFinder.init();
catToggle.init();
dropdown.init();
detectSticky.init();
breadcrumbs.init();
stickySidebar.init();
addEvent();
appHeight();
